import { render } from "./EndOfContratDatatable.vue?vue&type=template&id=018a9bdf"
import script from "./EndOfContratDatatable.vue?vue&type=script&lang=ts"
export * from "./EndOfContratDatatable.vue?vue&type=script&lang=ts"

import "./EndOfContratDatatable.vue?vue&type=style&index=0&id=018a9bdf&lang=scss"
script.render = render

export default script